var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-header"},[_c('div',{staticClass:"form-header--title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-header--text"},[_vm._v("\n        "+_vm._s(_vm.desc)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }